import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useLanguage, languageOptions } from '../context/LanguageContext';
import { useCurrency, currencyOptions } from '../context/CurrencyContext';
import { Globe, DollarSign } from 'lucide-react';

export const LanguageSelector = ({ className = '' }) => {
  const { language, setLanguage } = useLanguage();
  
  return (
    <Select value={language} onValueChange={setLanguage}>
      <SelectTrigger className={`w-auto gap-2 rounded-lg border-deep-charcoal/20 bg-white/50 ${className}`} data-testid="language-selector">
        <Globe className="w-4 h-4 text-deep-charcoal/60" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {languageOptions.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            {lang.nativeName}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export const CurrencySelector = ({ className = '' }) => {
  const { currency, setCurrency } = useCurrency();
  
  return (
    <Select value={currency} onValueChange={setCurrency}>
      <SelectTrigger className={`w-auto gap-2 rounded-lg border-deep-charcoal/20 bg-white/50 ${className}`} data-testid="currency-selector">
        <DollarSign className="w-4 h-4 text-deep-charcoal/60" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {currencyOptions.map((curr) => (
          <SelectItem key={curr.code} value={curr.code}>
            {curr.symbol} {curr.code}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export const LocaleSelectors = ({ className = '' }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LanguageSelector />
      <CurrencySelector />
    </div>
  );
};
